module.exports = __webpack_public_path__ + "static/media/invite.f6092dbc.png";